<template>
  <div>
    <div class="p-configurator" v-show="hasCarType">
      <div class="p-configurator__col">
        <div class="p-name">
          <h1 class="p-name__ttl c-ttl">{{ name }}</h1>
          <div class="p-name__btns">
            <button class="c-btn c-btn--small" @click="showCarTypeChangeModal">
              車種を変更する
            </button>
          </div>
        </div>

        <carousel ref="carousel" :carouselImages="carouselImages"></carousel>

        <div class="p-configurator__col__menu">
          <div v-for="endItem in endItems" :key="endItem.identifier" class="p-configurator__col__menu__item">
            <template v-if="selectedNav === endItem.identifier">
              <change-menu :identifier="endItem.identifier" :selectedItem="selectedItem"
                :selectMenu="select[endItem.identifier]" :stoppedEnditems="stoppedEnditems"
                :gtsExteriorMap="gtsExteriorMap" :gtsExteriorAeroCombination="gtsExteriorAeroCombination" device="pc"
                @change-menu="changeMenu" @change-grade="changeGrade"></change-menu>
            </template>
          </div>
        </div>
      </div>

      <div class="p-configurator__col2">
        <div class="p-result">
          <div class="p-result__row">
            <dl class="p-result__code">
              <dt>
                アルピーヌコード
                <span class="p-result__code__btn">
                  <a href="javascript:;" class="c-btn-info" @click.prevent="showCodeModal">i</a>
                </span>
              </dt>
              <dd>{{ btocode }}</dd>
            </dl>
            <ul class="p-result__btns">
              <li>
                <button class="c-btn" @click="print">印刷</button>
              </li>
              <!-- <li>
                <form :action="reservationUrl" target="_blank" method="POST" @submit.prevent="reserveDeal">
                  <input type="hidden" name="btocode" :value="btocode" />
                  <button type="submit" class="c-btn c-btn--fill c-btn--sp-large"
                    v-bind:class="{ 'is-disabled': cantReserve }">
                    商談予約画面へ進む
                  </button>
                </form>
              </li> -->
            </ul>
          </div>
          <div class="p-result__row2">
            <div class="p-result__row3">
              <p class="p-result__txt c-ttl2">合計価格</p>
              <p class="p-result__value">
                <span class="p-result__price c-price">
                  <span class="p-result__price__value c-price__value">
                    {{ selectedItem.total_price | addComma }}
                  </span>
                  <span class="p-result__price__unit c-price__unit">円</span>
                </span>
              </p>
            </div>
            <p class="p-result__reset">
              <a href="javascript:;" @click.prevent="showResetModal">変更内容をリセット</a>
            </p>
          </div>
        </div>

        <div class="p-conversions">
          <div v-for="endItem in endItems" :key="endItem.identifier">
            <conversion :identifier="endItem.identifier" :select="select" :selectedItem="selectedItem"
              :selectedNav="selectedNav" :basePrice="basePrice" :clickable="endItem.clickable"
              :hasBorder="endItem.hasBorder" :hasHeading="endItem.hasHeading" :stoppedEnditems="stoppedEnditems"
              :gtsExteriorMap="gtsExteriorMap" :gtsExteriorAeroCombination="gtsExteriorAeroCombination"
              @change-selected-nav="changeSelectedNav" @change-menu="changeMenu" @change-grade="changeGrade">
            </conversion>
          </div>
        </div>

        <form @submit.prevent="reflectCode">
          <dl class="p-code">
            <dt class="p-code__ttl c-ttl2">ディーラー入力用アルピーヌコード</dt>
            <dd class="p-code__detail">
              <div class="p-code__detail__input">
                <input type="text" class="p-code__form" v-model="dealerBtocode" />
              </div>
              <div class="p-code__detail__btn">
                <button type="submit" class="p-code__btn">反映</button>
              </div>
            </dd>
          </dl>
        </form>
      </div>

      <div class="p-configurator__floating">
        <div class="p-configurator__floating__row">
          <div class="p-configurator__floating__info">
            <p class="p-configurator__floating__name">{{ name }}</p>
            <p class="p-configurator__floating__value">
              <span class="p-configurator__floating__price c-price">
                <span class="p-configurator__floating__price__value c-price__value">{{ selectedItem.total_price |
                  addComma
                  }}</span>
                <span class="p-configurator__floating__price__unit c-price__unit">円</span>
              </span>
            </p>
          </div>
          <div class="p-configurator__floating__conversion">
            <div class="p-configurator__floating__btn">
              <button class="c-btn c-btn--small" @click="showCarTypeChangeModal">
                車種変更
              </button>
              <!-- <form :action="reservationUrl" target="_blank" method="POST" @submit.prevent="reserveDeal">
                <input type="hidden" name="btocode" :value="btocode" />
                <button type="submit" class="c-btn c-btn--small c-btn--fill"
                  v-bind:class="{ 'is-disabled': cantReserve }">
                  商談予約
                </button>
              </form> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 車種選択モーダル -->
    <modal ref="carTypeSelectModal" modalType="2" :bgClickable="false">
      <ul class="p-modal__car-type">
        <li v-for="carType in carTypes" :key="carType.id">
          <a href="javascript:;" @click.stop="changeCarType(carType.id)">
            <div class="p-modal__car-type__img">
              <img :src="`./assets/img/cartype/${carType.id}.jpg`" alt />
            </div>
            <span class="p-modal__car-type__name">{{ carType.name }}</span>
          </a>
        </li>
      </ul>
    </modal>

    <!-- 車種変更モーダル -->
    <modal ref="carTypeChangeModal" modalType="2" :bgClickable="true">
      <ul class="p-modal__car-type">
        <li v-for="carType in carTypes" :key="carType.id">
          <a href="javascript:;" @click.stop="changeCarType(carType.id)">
            <div class="p-modal__car-type__img">
              <img :src="`./assets/img/cartype/${carType.id}.jpg`" alt />
            </div>
            <span class="p-modal__car-type__name">{{ carType.name }}</span>
          </a>
        </li>
      </ul>
    </modal>

    <!-- アルピーヌコードモーダル -->
    <modal ref="codeModal">
      <h2 class="p-modal-ttl">アルピーヌコードとは？</h2>
      <p class="p-modal-txt">
        アルピーヌコードによりあなたが作成したコンフィギュレーションを簡単に呼び出すことができます。
      </p>
      <ul class="p-modal-btns">
        <li>
          <button class="c-btn c-btn--fill" @click="hideCodeModal">
            閉じる
          </button>
        </li>
      </ul>
    </modal>

    <!-- リセットモーダル -->
    <modal ref="resetModal">
      <p class="p-modal-txt2">
        選択した内容を
        <br />すべてリセットしますか？
      </p>
      <ul class="p-modal-btns">
        <li>
          <button class="c-btn" @click="hideResetModal">戻る</button>
        </li>
        <li>
          <button class="c-btn c-btn--fill" @click="reset">OK</button>
        </li>
      </ul>
    </modal>

    <!-- エラーモーダル -->
    <modal ref="errorModal">
      <p class="p-modal-txt2" v-html="errorTxt"></p>
      <ul class="p-modal-btns">
        <li>
          <button class="c-btn c-btn--fill" @click="hideErrorModal">
            閉じる
          </button>
        </li>
      </ul>
    </modal>

    <!-- エラーモーダル -->
    <modal ref="cantSubmitModal">
      <p class="p-modal-txt2">
        選択されたオプションは受け付けていないため<br />
        商談予約へは進むことができません。<br />
        選択し直して下さい。
      </p>
      <ul class="p-modal-btns">
        <li>
          <button class="c-btn c-btn--fill" @click="hideCantSubmitModal">
            閉じる
          </button>
        </li>
      </ul>
    </modal>

    <!-- 旧アルピーヌコードを入力したときのモーダル -->
    <modal ref="oldBtocodeModal">
      <p class="p-modal-txt2">
        ご入力いただいたアルピーヌコードは変更となりました。<br>
        新しいアルピーヌコード（選択オプションは同じ）の内容を反映します。
      </p>
      <ul class="p-modal-btns">
        <li>
          <button class="c-btn c-btn--fill" @click="hideOldBtocodeModal">
            閉じる
          </button>
        </li>
      </ul>
    </modal>


    <!-- A110 BLEU ALPINE EDITION選択時のモーダル -->
    <modal ref="bleuAlipnelModal">
      <p class="p-modal-txt">
        選択いただいた組み合わせは限定車<br>
        「A110 BLEU ALPINE EDITION」の仕様です。<br>
        限定車の詳細については下記の「詳しく見る」よりご確認ください。
      </p>
      <ul class="p-modal-btns">
        <li>
          <button class="c-btn" @click="hideBleuAlipnelModal">
            戻る
          </button>
        </li>
        <li>
          <a class="c-btn c-btn--fill" href="https://www.alpinecars.jp/model/a110-bleu-alpine-edition/" target="_blank">
            詳しく見る
          </a>
        </li>
      </ul>
    </modal>

    <!-- 特定モデル選択時のモーダル -->
    <modal ref="essentialModal">
      <p class="p-modal-txt">
        選択いただいた組み合わせはエッセンシャルパッケージの仕様です。<br>
        エッセンシャルパッケージは受注生産モデルに比べて、早めの納車が可能です。
      </p>
      <ul class="p-modal-btns">
        <li>
          <button class="c-btn c-btn--fill" @click="hideEssentialModal">
            閉じる
          </button>
        </li>
      </ul>
    </modal>

    <!-- ローディング -->
    <loading ref="loading"></loading>
  </div>
</template>

<script>
import Carousel from "../components/Carousel";
import Conversion from "../components/Conversion";
import ChangeMenu from "../components/ChangeMenu";
import Modal from "../components/Modal";
import Loading from "../components/Loading";
import { CAR_TYPES } from "../const/const";
import { zeroPadding } from "../util/util";
import { addComma } from "../util/filter";
import WorkerFetch from 'worker-loader!@/workers/worker.fetch'

const ASSET_IMG_PATH = "./assets/img";

window.carItems = {
  a110gts: {},
  a110r: {},
}

export default {
  name: "Home",
  data() {
    return {
      all: {
        a110gts: {
          isLoaded: false,
          name: null,
          base_price: null,
          select: {
            grade: null,
            wheel: null,
            caliper: null,
            roof: null,
            gtsExteriorRoof: null,
            gtsExteriorAero: null,
            gtsExteriorExhaust: null,
            interior: null,
            color: {
              default: null,
              atelier: null,
              exclusive: null,
            },
          },
        },
        a110r: {
          isLoaded: false,
          name: null,
          base_price: null,
          select: {
            grade: null,
            wheel: null,
            caliper: null,
            roof: null,
            interior: null,
            color: {
              default: null,
              atelier: null,
              exclusive: null,
            },
          },
        },
      },
      selectedItem: {
        btocode: null,
        total_price: 0,
        enditem: {
          grade: null,
          wheel: null,
          caliper: null,
          roof: null,
          interior: null,
          color: null,
        },
      },
      selectedNav: "",
      // 商談予約のURL
      reservationUrl: "https://www.renault.jp/alpine/reservation_bto/index.php",
      // reservationUrl: "https://stg.renault.jp/alpine/reservation_bto/index.php", // 開発中用のstgのURL
      // 車種変更UI用
      carTypes: CAR_TYPES,
      // 切り替えUI用
      endItems: [
        {
          identifier: "grade",
          clickable: false,
          hasBorder: true,
          hasHeading: false,
        },
        {
          identifier: "color",
          clickable: true,
          hasBorder: false,
          hasHeading: true,
        },
        {
          identifier: "roof",
          clickable: true,
          hasBorder: false,
          hasHeading: false,
        },
        {
          identifier: "gtsExteriorRoof",
          clickable: true,
          hasBorder: false,
          hasHeading: false,
        },
        {
          identifier: "gtsExteriorAero",
          clickable: true,
          hasBorder: false,
          hasHeading: false,
        },
        {
          identifier: "gtsExteriorExhaust",
          clickable: true,
          hasBorder: false,
          hasHeading: false,
        },
        {
          identifier: "wheel",
          clickable: true,
          hasBorder: false,
          hasHeading: false,
        },
        {
          identifier: "tire",
          clickable: true,
          hasBorder: false,
          hasHeading: false,
        },
        {
          identifier: "caliper",
          clickable: true,
          hasBorder: false,
          hasHeading: false,
        },
        {
          identifier: "interior",
          clickable: true,
          hasBorder: false,
          hasHeading: false,
        },
        {
          identifier: "handle",
          clickable: true,
          hasBorder: false,
          hasHeading: false,
        },
      ],
      // a110gtsのエクステリアのパーツ情報
      // アルピーヌコードに紐づいた処理
      gtsExteriorRoof: {
        "1": {
          name: "標準ルーフ",
          price: 0,
          order: 10,
        },
        "2": {
          name: "カーボンルーフ",
          price: 300000,
          order: 20,
        },
      },
      // アルピーヌコードに紐づいた処理
      gtsExteriorAero: {
        "1": {
          name: "なし",
          price: 0,
          order: 10,
        },
        "2": {
          name: "エアロキット",
          price: 650000,
          order: 20,
        },
        "3": {
          name: "Rエアロキット",
          price: 1850000,
          order: 30,
        },
      },
      // アルピーヌコードに紐づいた処理
      gtsExteriorExhaust: {
        "1": {
          name: "スポーツエキゾースト",
          price: 0,
          order: 10,
        },
        "2": {
          name: "二重構造デュアルエキゾースト",
          price: 0,
          order: 20,
        },
        "3": {
          name: "GTS専用アクラポヴィッチ製チタンエキゾースト",
          price: 1000000,
          order: 30,
        },
        "4": {
          name: "R専用アクラポヴィッチ製チタンエキゾースト",
          price: 1000000,
          order: 40,
        },
      },
      // a110gtsにおいてエクステリア3つの組み合わせとアルピーヌコードの対応表（以下シート参照）
      // https://docs.google.com/spreadsheets/d/1WvOa-YliGIJMRSw6oIfxoS_9Y5D3q8k9SAYo9shj_AU/edit?gid=331673537#gid=331673537
      // アルピーヌコードに紐づいた処理
      gtsExteriorMap: {
        H: {
          gtsExteriorRoof: 1,
          gtsExteriorAero: 1,
          gtsExteriorExhaust: 1,
        },
        B: {
          gtsExteriorRoof: 1,
          gtsExteriorAero: 2,
          gtsExteriorExhaust: 1,
        },
        E: {
          gtsExteriorRoof: 1,
          gtsExteriorAero: 1,
          gtsExteriorExhaust: 3,
        },
        G: {
          gtsExteriorRoof: 1,
          gtsExteriorAero: 2,
          gtsExteriorExhaust: 3,
        },
        K: {
          gtsExteriorRoof: 1,
          gtsExteriorAero: 3,
          gtsExteriorExhaust: 2,
        },
        M: {
          gtsExteriorRoof: 1,
          gtsExteriorAero: 3,
          gtsExteriorExhaust: 4,
        },
        A: {
          gtsExteriorRoof: 2,
          gtsExteriorAero: 1,
          gtsExteriorExhaust: 1,
        },
        C: {
          gtsExteriorRoof: 2,
          gtsExteriorAero: 2,
          gtsExteriorExhaust: 1,
        },
        F: {
          gtsExteriorRoof: 2,
          gtsExteriorAero: 1,
          gtsExteriorExhaust: 3,
        },
        J: {
          gtsExteriorRoof: 2,
          gtsExteriorAero: 2,
          gtsExteriorExhaust: 3,
        },
        L: {
          gtsExteriorRoof: 2,
          gtsExteriorAero: 3,
          gtsExteriorExhaust: 2,
        },
        N: {
          gtsExteriorRoof: 2,
          gtsExteriorAero: 3,
          gtsExteriorExhaust: 4,
        },
      },
      // a110gtsにおいてエアロに紐づいてエキゾーストが更新されるためその対応表
      // エアロ起点となる
      // アルピーヌコードに紐づいた処理
      gtsExteriorAeroCombination: {
        1: [1, 3],
        2: [1, 3],
        3: [2, 4],
      },
      carouselLength: 6,
      //
      dealerBtocode: null,
      errorTxt: "",
      newBtocodeItem: null,
      isShowOldBtocodeModal: false,
      // cantReserve: false,
      // forEssentialModalCarType: "",
      // アルピーヌコードに紐づいた処理
      bleuAlipneCodes: [
        "JAQBH-RQR",
        "GB-BD6RQR",
      ],
      // アルピーヌコードに紐づいた処理
      essentialCodes: [],
      // 旧アルピーヌコードと新アルピーヌコードのグレード部分の対応表
      // アルピーヌコードに紐づいた処理
      oldBtoCodeGradeMap: {},
      // 受注停止のエンドアイテム
      // アルピーヌコードに紐づいた処理
      stoppedEnditems: {
        // 色は全車種共通
        colors: []
      },
    };
  },
  components: {
    Conversion,
    ChangeMenu,
    Carousel,
    Modal,
    Loading,
  },
  async created() {
  },
  async mounted() {
    // 車種が選択されていない時は車種選択のモーダルを表示する
    if (!this.hasCarType) {
      this.showCarTypeSelectChangeModal();
      // スクロールに伴う処理
      this.onScrollEvents();
      return;
    }

    await this.asignCarData();

    const queryBtoCode = this.$route.query.code;

    // queryがある場合
    if (this.$route.query && queryBtoCode) {
      let btoCode;
      if (this.isOldBtoCode(queryBtoCode)) {
        this.isShowOldBtocodeModal = true;
        btoCode = this.getNewBtoCode(queryBtoCode);
        this.$router.replace({ query: { code: btoCode } });
      } else {
        btoCode = queryBtoCode;
      }
      // queryを元にデータを特定
      let item = this.allItems.find(
        (obj) => obj.btocode === btoCode
      );

      // データがない場合はエラーを表示して選択状態を解除する
      if (!item) {
        this.errorBtoCode();
        this.reset();
        // スクロールに伴う処理
        this.onScrollEvents();
        return;
      }

      // A110 BLEU ALPINE EDITIONの場合はモーダルを表示する
      if (this.isBleuAlipneCode(item.btocode)) {
        this.showBleuAlipnelModal();
      }
      // エッセンシャルパッケージ仕様の場合はモーダルを表示する
      else if (this.isEessentialCode(item.btocode)) {
        this.showEssentialModal();
      }
      // 古いアルピーヌコードの場合はモーダルを表示する
      else if (this.isShowOldBtocodeModal) {
        this.showOldBtocodeModal();
      }
      this.isShowOldBtocodeModal = false;
      this.setSelectedItem(item);
    } else {
      // 選択アイテム更新
      this.setSelectedItem(this.allItems[0]);
    }

    // レンダリング後（？）に実行される処理
    this.$nextTick(() => {
      // ローディング消去
      this.$refs.loading.hide();
      // スクロールに伴う処理
      this.onScrollEvents();
      // カルーセル
      this.$refs.carousel.init();
    });
  },
  computed: {
    allItems() {
      if (!this.currentCarType) return;
      return window.carItems[this.currentCarType];
    },
    select() {
      if (!this.currentCarType) return;
      return this.all[this.currentCarType].select;
    },
    name() {
      if (!this.currentCarType) return;
      return this.all[this.currentCarType].name;
    },
    basePrice() {
      if (!this.currentCarType) return;
      return this.all[this.currentCarType].base_price;
    },
    currentCarType() {
      return this.$route.params.cartype;
    },
    hasCarType() {
      if (CAR_TYPES.some((CAR_TYPE) => CAR_TYPE.id === this.currentCarType)) {
        return true;
      } else {
        return false;
      }
    },
    carouselImages() {
      if (!this.btocode) return;
      let carouselImages = [];

      // 画像名を定義するため、btoコード文字列を置き換える
      // アルピーヌコードに紐づいた処理
      let btocode = this.btocode;
      let btocodes = btocode.split("");
      if (btocodes[0] === "K") {
        btocodes[0] = "J";
      } else if (btocodes[0] === "H") {
        btocodes[0] = "G";
      }
      // a110r のルーフはカーボンルーフだけで、マフラー有無で画像が変わらないので、ルーフコードを丸める
      // if (this.currentCarType === "a110r") {
      //   if (btocodes[4] === "D") {
      //     btocodes[4] = "A";
      //   }
      // }

      // GTSの特定の場合、コードを書き換える
      // アルピーヌコードに紐づいた処理
      if (this.currentCarType === "a110gts") {
        // ホイールのコード書き換え対応表
        const wheelMap = {
          "2": "R",
          "3": "A",
          "4": "K",
          "6": "M",
          "8": "Q",
          "9": "S"
        };
        // ホイールが特定のものの場合,対応表を元に書き換える
        if (wheelMap[btocodes[2]]) {
          btocodes[2] = wheelMap[btocodes[2]];
        }
      }
      // Rの特定の場合、コードを書き換える
      // アルピーヌコードに紐づいた処理
      else if (this.currentCarType === "a110r") {
        const roofMap = {
          D: "-"
        };
        if (roofMap[btocodes[4]]) {
          btocodes[4] = roofMap[btocodes[4]];
        }
      }

      btocode = btocodes.join("");

      for (let i = 0; i < this.carouselLength; i++) {
        let imgName = "";

        // 1〜4枚目と5〜6枚目で画像名のルールを変更
        // アルピーヌコードに紐づいた処理
        // アルピーヌコードのルール
        // 1-2桁目：グレード
        // 3桁目：ホイール
        // 4桁目：キャリパー
        // 5桁目：ルーフ
        // 6桁目：インテリア
        // 7〜9桁目：カラー（3桁）
        if (i < 4) {
          // 6桁目（インテリア）を削除する
          imgName = btocode.slice(0, 5) + btocode.slice(6);
        } else {
          // 3〜5桁目（ホイール、キャリパー、ルーフ）を削除
          imgName = btocode.slice(0, 2) + btocode.slice(5);
        }

        // グレードの2桁目は不要なため削除する
        // アルピーヌコードに紐づいた処理
        imgName = imgName.slice(0, 1) + imgName.slice(2);

        carouselImages.push(
          ASSET_IMG_PATH +
          "/car/" +
          imgName +
          "_" +
          zeroPadding(i + 1, 2) +
          ".jpg"
        );
      }

      return carouselImages;
    },
    btocode() {
      if (!this.selectedItem.btocode) return;
      return this.selectedItem.btocode;
    },
    cantReserve() {
      // 受注停止状態にある場合またはA110 BLEU ALPINE EDITIONの場合は商談予約ボタンが非活性化する
      if (this.btocode && (this.isStoppedCode(this.btocode) || this.isBleuAlipneCode(this.btocode))) {
        return true;
      }
      return false;
    }
  },
  watch: {
    async $route(to, from) {
      const queryBtoCode = this.$route.query.code;

      // pathが書き換わらない場合、queryをチェックする
      if (to.path === from.path) {
        // queryがある場合
        if (this.$route.query && queryBtoCode) {
          // queryを元にデータを特定
          let item = this.allItems.find(
            (obj) => obj.btocode === queryBtoCode
          );
          // データがない場合はエラーを表示して選択状態を解除する
          if (!item) {
            this.errorBtoCode();
            this.reset();
            return;
          }
          this.setSelectedItem(item);
        }
        // queryがない場合
        else {
          // selectedNav初期化
          this.changeSelectedNav("");
          // 車種変更された場合用
          this.$refs.loading.hide();
          //
          this.setSelectedItem(this.allItems[0]);
        }
      }
      // pathが書き換わっている場合、車種が定数で定義されているものとマッチした時はデータ取得
      else if (
        CAR_TYPES.some((CAR_TYPE) => CAR_TYPE.id === this.currentCarType)
      ) {
        await this.asignCarData();
        // selectedNav初期化
        this.changeSelectedNav("");
        // 選択されているアイテムの更新
        if (!this.newBtocodeItem) {
          this.setSelectedItem(this.allItems[0]);
        } else {
          this.setSelectedItem(this.newBtocodeItem);
          this.newBtocodeItem = null;
        }
        // モーダルを非表示に
        Object.keys(this.$refs).forEach((key) => {
          if (typeof this.$refs[key].hide === "function") {
            this.$refs[key].hide();
          }
        });
        // カルーセル更新
        this.$refs.carousel.init();
      }
      // マッチしなかった場合は車種選択モーダルを表示する
      else {
        this.showCarTypeSelectChangeModal();
      }
    },
    /**
     *
     */
    selectedItem(newData, oldData) {
      if (!oldData.btocode) return;
      this.$router.push({ query: { code: this.btocode } }).catch(() => { });
    },
  },
  methods: {
    async asignCarData(carTypeId = this.$route.params.cartype) {
      // すでに読み込まれたデータであれば再取得しない
      if (this.all[carTypeId].isLoaded) return;
      const carData = await this.getCarData(carTypeId);
      this.setCarData(carData, carTypeId);

    },
    setCarData(data, carTypeId) {
      // jsonの中の車種事の情報は膨大すぎて重いためリアクティブなデータとして扱わない
      window.carItems[carTypeId] = data.items;

      // items以外のデータはリアクティブなデータとして扱う
      this.all[carTypeId].name = data.name;
      this.all[carTypeId].base_price = data.base_price;

      // a110rのselectのcolorの中身を変更する
      // アルピーヌコードに紐づいた処理
      if (carTypeId === "a110r") {
        const newColorObj = { ...data.select.color.default, ...data.select.color.atelier, ...data.select.color.exclusive };
        data.select.color = newColorObj;
      } else if (carTypeId === "a110gts") {
        data.select.gtsExteriorRoof = this.gtsExteriorRoof;
        data.select.gtsExteriorAero = this.gtsExteriorAero;
        data.select.gtsExteriorExhaust = this.gtsExteriorExhaust;
      }
      this.all[carTypeId].select = data.select;

      // 一度取得したデータは再取得させないための処理
      this.all[carTypeId].isLoaded = true;
    },
    getCarData(carTypeId) {
      return new Promise((resolve) => {
        const workerFetch = new WorkerFetch();
        workerFetch.onmessage = e => {
          const data = e.data;
          resolve(data);
        }
        workerFetch.postMessage(carTypeId);
      });
    },
    /**
     * SP表示時スクロールに伴って、行う処理
     */
    onScrollEvents() {
      const elBody = document.body;
      const elCarouselTrigger = document.querySelector(".p-carousel-wrap");
      const stateCarouselFixed = "is-carousel-fixed";
      const stateFloatingShow = "show-floating";

      window.addEventListener(
        "scroll",
        function () {
          let carouselTriggerTop =
            elCarouselTrigger.getBoundingClientRect().top;

          if (carouselTriggerTop < 0) {
            elBody.classList.add(stateCarouselFixed);
            elBody.classList.add(stateFloatingShow);
          } else {
            elBody.classList.remove(stateCarouselFixed);
            elBody.classList.remove(stateFloatingShow);
          }
        },
        false
      );
    },

    /**
     *
     */
    setSelectedItem(selectedItem) {
      // アルピーヌコードがA110 BLEU ALPINE EDITIONの場合は、モーダルを出す
      if (this.isBleuAlipneCode(selectedItem.btocode)) {
        this.showBleuAlipnelModal();
      }

      // btoコードがエッセンシャルコードの場合は、モーダルを出す
      if (this.isEessentialCode(selectedItem.btocode)) {
        this.showEssentialModal();
        // return;
      }

      // a110gtsの場合は必要なデータを足す
      // アルピーヌコードに紐づいた処理
      let newSelectedItem = { ...selectedItem };
      if (this.currentCarType === "a110gts") {
        let endItem = newSelectedItem.enditem;
        newSelectedItem.enditem = { ...newSelectedItem.enditem, ...this.gtsExteriorMap[endItem.roof] }
      }

      this.selectedItem = newSelectedItem;
    },

    /**
     * 選択されているナビ変更
     */
    changeSelectedNav(selectedNav) {
      this.selectedNav = selectedNav;
    },

    /**
     * 車種変更
     */
    changeCarType(carTypeId) {
      this.hideCarTypeChangeModal();
      this.hideCarTypeSelectChangeModal();
      if (this.currentCarType !== carTypeId) {
        // ローディング表示
        this.$refs.loading.show(0.7);
        this.$router.push({ path: `./${carTypeId}` }).catch(() => { });
      }
    },

    /**
     * 車種選択モーダル
     */
    showCarTypeSelectChangeModal() {
      this.$refs.carTypeSelectModal.show();
    },

    /**
     * 車種選択モーダル
     */
    hideCarTypeSelectChangeModal() {
      this.$refs.carTypeSelectModal.hide();
    },

    /**
     * 車種変更モーダル
     */
    showCarTypeChangeModal() {
      this.$refs.carTypeChangeModal.show();
    },

    /**
     * 車種変更モーダル
     */
    hideCarTypeChangeModal() {
      this.$refs.carTypeChangeModal.hide();
    },

    /**
     * 商談予約
     */
    reserveDeal(/*event*/) {
      // 予約不可の場合で、A110 BLEU ALPINE EDITIONの場合は専用のモーダルを表示する
      if (this.cantReserve && this.isBleuAlipneCode(this.btocode)) {
        this.showBleuAlipnelModal();
        return;
      }

      // 予約不可の場合は処理しないでエラーモーダル表示
      if (this.cantReserve) {
        this.showCantSubmitModal();
        return;
      }
      // event.target.submit();
    },

    /**
     * アルピーヌコード反映
     */
    async reflectCode() {
      // 未入力の場合は何も処理しない
      if (!this.dealerBtocode || this.dealerBtocode.length === 0) {
        return;
      }

      // 文字数が9文字でなければエラーを表示
      // アルピーヌコードに紐づいた処理
      if (this.dealerBtocode.length !== 9) {
        this.errorReflectCode();
      }
      // 旧アルピーヌコードの場合はアルピーヌコードを変換しつつモーダルを表示する
      else if (this.isOldBtoCode(this.dealerBtocode)) {
        this.isShowOldBtocodeModal = true;
        this.convertOldCodeToNewCode();
        this.reflectCode();
      }
      // 上記のエラーがない場合はデータを取得しコードのチェックを行う
      else {
        // ローディング表示
        this.$refs.loading.show(0.7);

        // データ取得
        for (let key in this.all) {
          await this.asignCarData(key);
        }

        // コードチェック
        let code = this.dealerBtocode;
        // 全角の文字を半角に変更
        code = code.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (string) {
          return String.fromCharCode(string.charCodeAt(0) - 0xfee0);
        });
        // 全角のハイフンを半角に変換
        code = code.replace(/ー/g, "-").replace(/－/g, "-");
        // 大文字に変換
        code = code.toUpperCase();
        // コードのチェック
        let catTypeId = null;
        let valid = false;
        let item = null;
        Object.keys(this.all).forEach((key) => {
          if (valid) return;
          window.carItems[key].some((obj) => {
            if (obj.btocode === code) {
              catTypeId = key;
              valid = true;
              item = obj;
            }
          });
        });

        // ローディング消去
        this.$refs.loading.hide();

        // コードが正しければ車を更新
        if (valid) {
          // アルピーヌコードがA110 BLEU ALPINE EDITIONかどうかチェック
          if (this.isBleuAlipneCode(item.btocode)) {
            this.isShowOldBtocodeModal = false;
            this.showBleuAlipnelModal();
          }

          // btoコードがエッセンシャルパッケージかどうかチェック
          if (this.isEessentialCode(item.btocode)) {
            // エッセンシャルモーダル用のカータイプを設定
            // this.forEssentialModalCarType = catTypeId;
            this.isShowOldBtocodeModal = false;
            this.showEssentialModal();
            // return;
          }


          // 条件を満たす時bto変換モーダルを表示する
          if (this.isShowOldBtocodeModal) {
            this.showOldBtocodeModal();
            return;
          }

          // 車種切り替えの場合
          if (this.currentCarType !== catTypeId) {
            this.newBtocodeItem = item;
            this.changeCarType(catTypeId);
          }
          // 同一車種の場合
          else {
            this.setSelectedItem(item);
          }
        }
        // コードが不正であればエラー表示
        else {
          this.errorReflectCode();
        }
      }
    },

    /**
     * アルピーヌコードエラー
     */
    errorReflectCode() {
      this.errorTxt = "アルピーヌコードが不正です。入力しなおしてください。";
      this.showErrorModal();
    },

    /**
     * アルピーヌコードエラー(車種の初期ページに戻す場合)
     */
    errorBtoCode() {
      this.errorTxt = `アルピーヌコードが不正です。<br>${this.name}の初期ページを表示します。`;
      this.showErrorModal();
    },

    /**
     * エラーモーダル表示
     */
    showErrorModal() {
      this.$refs.errorModal.show();
    },

    /**
     * エラーモーダル非表示
     */
    hideErrorModal() {
      this.$refs.errorModal.hide();
    },

    /**
     * サブミット不可モーダル
     */
    showCantSubmitModal() {
      this.$refs.cantSubmitModal.show();
    },

    /**
     * サブミット不可モーダル非表示
     */
    hideCantSubmitModal() {
      this.$refs.cantSubmitModal.hide();
    },

    /**
     * 旧アルピーヌコード入力モーダル表示
     */
    showOldBtocodeModal() {
      this.$refs.oldBtocodeModal.show();
    },

    /**
     * 旧アルピーヌコード入力モーダル非表示
     */
    hideOldBtocodeModal() {
      this.$refs.oldBtocodeModal.hide();
      this.isShowOldBtocodeModal = false;
      // btoコード反映を行う
      this.reflectCode();
    },

    /**
     * A110 BLEU ALPINE EDITION用のモーダル表示
     */
    showBleuAlipnelModal() {
      this.$refs.bleuAlipnelModal.show();
    },

    /**
     * A110 BLEU ALPINE EDITION用のモーダル非表示
     */
    hideBleuAlipnelModal() {
      this.$refs.bleuAlipnelModal.hide();
    },

    /**
     * エッセンシャルパッケージ用のモーダル表示
     */
    showEssentialModal() {
      this.$refs.essentialModal.show();
    },

    /**
     * エッセンシャルパッケージ用のモーダル非表示
     */
    hideEssentialModal() {
      // this.forEssentialModalCarType = "";
      this.$refs.essentialModal.hide();
    },

    /**
     * 印刷
     */
    print() {
      window.print();
    },

    /**
     * リセットモーダル表示
     */
    showResetModal() {
      this.$refs.resetModal.show();
    },

    /**
     * リセットモーダル非表示
     */
    hideResetModal() {
      this.$refs.resetModal.hide();
    },

    /**
     * リセット
     */
    reset() {
      this.$router.push({ query: null }).catch(() => { });
      this.setSelectedItem(this.allItems[0]);
      this.$refs.resetModal.hide();
    },

    /**
     * アルピーヌコードの説明表示
     */
    showCodeModal() {
      this.$refs.codeModal.show();
    },

    /**
     * アルピーヌコードの説明非表示
     */
    hideCodeModal() {
      this.$refs.codeModal.hide();
    },

    /**
     *
     */
    changeMenu(code, type) {
      this.$refs.loading.show(0.7);
      // BTOコードの一覧と照らし合わせる
      let gradeCode = type === "grade" ? code : this.selectedItem.enditem.grade;
      let wheelCode = type === "wheel" ? code : this.selectedItem.enditem.wheel;
      let tireCode = type === "tire" ? code : this.selectedItem.enditem.tire;
      let caliperCode = type === "caliper" ? code : this.selectedItem.enditem.caliper;
      let roofCode = type === "roof" ? code : this.selectedItem.enditem.roof;
      let interiorCode = type === "interior" ? code : this.selectedItem.enditem.interior;
      let colorCode = type === "color" ? code : this.selectedItem.enditem.color;

      // 色で選別する（一番項目が減りそうなものから）
      let targetItem = this.allItems.filter(
        (item) => item.enditem.color === colorCode
      );
      // あとは順番に絞り込んでいく
      targetItem = targetItem.filter(
        (item) => item.enditem.grade === gradeCode
      );
      targetItem = targetItem.filter(
        (item) => item.enditem.wheel === wheelCode
      );
      targetItem = targetItem.filter(
        (item) => item.enditem.tire === tireCode
      );
      targetItem = targetItem.filter(
        (item) => item.enditem.caliper === caliperCode
      );
      targetItem = targetItem.filter(
        (item) => item.enditem.roof === roofCode
      );
      targetItem = targetItem.filter(
        (item) => item.enditem.interior === interiorCode
      );
      if (targetItem.length > 0) {
        // 選択されているアイテム更新
        this.setSelectedItem(targetItem[0]);
      } else {
        this.errorTxt =
          "選択したアイテムは利用できません。<br>他のアイテムを選択してください。";
        this.showErrorModal();
      }
      this.$refs.loading.hide();
    },

    /**
     * グレードの切り替え
     */
    changeGrade(grade) {
      // 対応するコード表
      // アルピーヌコードに紐づいた処理
      let gradeFirstCharMap = {
        "J": "K",
        "K": "J",
        "G": "H",
        "H": "G",
      };

      // 最初の1文字目を対応するマッピングに従って置き換える
      let grades = grade.split("");
      grades[0] = gradeFirstCharMap[grades[0]]
      let newGrade = grades.join("");

      // 切り替える
      this.changeMenu(newGrade, "grade");
    },
    /**
     * A110 BLEU ALPINE EDITIONのコードかどうかチェック
     */
    isBleuAlipneCode(btocode) {
      return this.bleuAlipneCodes.includes(btocode);
    },

    /**
     * エッセンシャルコードかどうかチェック
     */
    isEessentialCode(btocode) {
      return this.essentialCodes.includes(btocode);
    },
    /**
     * 受注停止状態のコードかどうかチェック
     */
    isStoppedCode(btocode) {
      if (!btocode) {
        return false;
      }

      // 無くなったカラーコードのための処理
      // コンフィギュレータで表示する事自体は必要なための処理
      // jsonから削除されたら削除する
      // 特定のカラーコードの場合、trueを返却する
      // アルピーヌコードに紐づいた処理
      if (this.isStoppedColor(btocode)) {
        return true;
      }
      else {
        return false;
      }
    },
    /**
     * 受注停止の色かどうかチェック
     */
    isStoppedColor(btocode) {
      const colorCode = btocode.slice(-3);
      return this.stoppedEnditems.colors.includes(colorCode);
    },
    /**
     * 古いアルピーヌコードかどうかチェック
     * アルピーヌコードに紐づいた処理
     */
    isOldBtoCode(btocode) {
      if (!btocode) {
        return false;
      }
      // コードの一文字目（グレード）が旧アルピーヌコードの場合
      if (this.oldBtoCodeGradeMap[btocode.charAt(0)]) {
        return true;
      }
      else {
        return false;
      }
    },
    /**
     * 古いアルピーヌコードを新しいコードに変換する
     * アルピーヌコードに紐づいた処理
     */
    convertOldCodeToNewCode() {
      if (!this.dealerBtocode) return;

      this.dealerBtocode = this.getNewBtoCode(this.dealerBtocode);
    },
    getNewBtoCode(oldBtoCode) {
      let newBtoCode = oldBtoCode;
      // グレードを変換
      const firstChar = newBtoCode.charAt(0);
      const otherChars = newBtoCode.slice(1);
      const newFirstChar = this.oldBtoCodeGradeMap[firstChar];
      newBtoCode = newFirstChar + otherChars;

      return newBtoCode;
    },
  },
  filters: {
    addComma,
  },
};
</script>
